export default __webpack_public_path__ + "static/media/apartment-cards-arrow.a59a3d21.svg";